/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type {
  ArticleServicesCurrencyFragmentFragment,
  ArticleServicesFragmentFragment,
} from '@packages/gql/generated/shopping/graphql';
import {
  ArticleServicesCurrencyFragmentFragmentDoc,
  ArticleServicesFragmentFragmentDoc,
} from '@packages/gql/generated/shopping/graphql';

export const articleServicesDataMock: ArticleServicesFragmentFragment = {
  clusters: [
    {
      label: 'Kostenlos für Dich dabei',
      services: [
        {
          serviceIcon: 'https://bilder.baur.de/i/empiriecom/service_baurde_INSTALLATION',
          uuid: '08740e0c-6f66-4ebc-a3a3-e26ae961f61a',
          name: 'Kostenloser Anschluss-Service',
          price: 0,
          gratis: true,
          preselected: true,
          mandatory: true,
        },
      ],
    },
    {
      label: 'Extra Schutz? Sichere Dich ab',
      services: [
        {
          serviceIcon: 'https://bilder.baur.de/i/empiriecom/service_baurde_LONG_TERM_WARRANTY',
          uuid: '7126f538-a39a-41e2-bb37-b6a971783967',
          name: '48 Monate Garantie',
          price: 50,
          gratis: false,
          preselected: false,
          mandatory: false,
        },
      ],
    },
    {
      label: 'EINFACH BEQUEM - WIR KÜMMERN UNS',
      services: [
        {
          serviceIcon: 'https://bilder.baur.de/i/empiriecom/service_baurde_OLD_PRODUCT_REMOVAL',
          uuid: '9fb7a4e7-f3a1-45ea-880e-f551ed3152fd',
          name: 'Altgeräte-Mitnahme',
          price: 14.99,
          gratis: false,
          preselected: false,
          mandatory: false,
        },
        {
          serviceIcon: 'https://bilder.baur.de/i/empiriecom/service_baurde_INSTALLATION',
          uuid: 'df320584-64ca-468b-8575-b39092537c44',
          name: 'Installations- und Einbau-Service für Einbaugeschirrspüler',
          price: 60,
          gratis: false,
          preselected: false,
          mandatory: false,
        },
      ],
    },
  ],
};

export function getArticleServicesFragmentedData(data?: ArticleServicesFragmentFragment) {
  return makeFragmentData(data || articleServicesDataMock, ArticleServicesFragmentFragmentDoc);
}

export const articleServicesCurrencyDataMock: ArticleServicesCurrencyFragmentFragment = {
  currency: 'EUR',
};

export function getArticleServicesCurrencyFragmentedData(
  data?: ArticleServicesCurrencyFragmentFragment,
) {
  return makeFragmentData(
    data || articleServicesCurrencyDataMock,
    ArticleServicesCurrencyFragmentFragmentDoc,
  );
}
